import PropTypes from 'prop-types';
import EmailTemplateCard from './email-template-card';
import EmptyStateMessage from 'components/lists/empty-state-message';

// Regular templates list component
const TemplatesList = ({ templates, openTemplateForm, selectedTemplate }) => {
  if (!templates || templates.length === 0) {
    return <EmptyStateMessage text="No templates found" />;
  }

  return (
    <>
      {templates.map((template) =>
        template && template.id ? (
          <EmailTemplateCard
            key={template.id}
            template={template}
            selectedTemplate={selectedTemplate}
            openTemplateForm={openTemplateForm}
          />
        ) : null
      )}
    </>
  );
};

TemplatesList.propTypes = {
  templates: PropTypes.array,
  openTemplateForm: PropTypes.func.isRequired,
  selectedTemplate: PropTypes.object,
};

export default TemplatesList;
